import { gql } from '@apollo/client'

export const AddChatReaction = gql`
    mutation AddChatReaction($roomId: ID!, $chatId: ID!, $emoji: String!) {
        addChatReaction(roomId: $roomId, chatId: $chatId, emoji: $emoji) {
            actor {
                id
                username
                avatar
            }
            id
            chatId
            emoji
            room {
                id
            }
            updated
        }
    }
`

export default AddChatReaction
